import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StorePerformanceInterval } from '../../../../../constants';
import { MemberOverviewResponse } from '../../../../../hooks';
import { Icons } from '../../../../../stories/atoms';
import { areaOverviewTranslations } from '../../../../../translations/areaOverview';
import { formatAmountWithSeparator } from '../../../../../utils';
import { OverviewWidget } from '../../../../areaOverview/overviewWidget/OverviewWidget';
import { AreaWidgetType } from '../../../../areaOverview/util';

type MemberOverviewWidgetProps = {
  interval: StorePerformanceInterval;
  data: MemberOverviewResponse | null;
  isLoading: boolean;
  isError: boolean;
  errorRetryHandler: () => void;
};

export const MemberOverviewWidget: FC<MemberOverviewWidgetProps> = observer(
  ({ data, isLoading, isError, errorRetryHandler }) => {
    const { t } = useTranslation();

    const memberSOR =
      data && data.totalTransactions !== 0 ? (data.memberTransactions / data.totalTransactions) * 100 : 0;
    const scoSOR =
      data && data.totalTransactions !== 0 ? (data.scoTransactions / data.totalTransactions) * 100 : 0;

    return (
      <OverviewWidget
        id={AreaWidgetType.MembersOverview}
        isLoading={isLoading}
        isError={isError}
        errorRetryHandler={errorRetryHandler}
        title={t(
          areaOverviewTranslations.memberOverview.title.key,
          areaOverviewTranslations.memberOverview.title.defaultValue,
        )}
        headerIcon={Icons.PROFILE}
        headerText={t(
          areaOverviewTranslations.memberOverview.headerText.key,
          areaOverviewTranslations.memberOverview.headerText.defaultValue,
        )}
        headerValue={formatAmountWithSeparator(data?.memberTransactions ?? 0)}
        widgetText={t(
          areaOverviewTranslations.memberOverview.widgetText.key,
          areaOverviewTranslations.memberOverview.widgetText.defaultValue,
        )}
        statistics={[
          {
            label: t(
              areaOverviewTranslations.memberOverview.memberSorText.key,
              areaOverviewTranslations.memberOverview.memberSorText.defaultValue,
            ),
            value: formatAmountWithSeparator(memberSOR, '%'),
          },
          {
            label: t(
              areaOverviewTranslations.memberOverview.scoSorText.key,
              areaOverviewTranslations.memberOverview.scoSorText.defaultValue,
            ),
            value: formatAmountWithSeparator(scoSOR, '%'),
          },
        ]}
      />
    );
  },
);
